import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import Button from './button';
import { backgroundButtonStyles } from './styles';

export function BackgroundButton(props) {
  const { className, classes, color, customEndIcon, customStartIcon, children, ...other } = props;

  return (
    <Button
      className={className}
      customStartIcon={customStartIcon}
      customEndIcon={customEndIcon}
      variant={null}
      classes={classes}
      {...other}
    >
      {children}
    </Button>
  );
}

export default withStyles(backgroundButtonStyles)(BackgroundButton);
